<template>
  <v-dialog v-model="internalShow" max-width="1000px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-text-field v-model="internalValue.path" label="Path"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="internalValue.comparison"
                :items="['','>', '<', '==', '!=']"
                label="Comparison"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="internalValue.value" label="Condition State key or value"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field v-model="internalValue.step" label="Next Step Key" disabled></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn large class="primary-btn" @click="internalShow = false">Close</v-btn>
        <v-btn large class="primary-btn" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      internalValue: { ...this.value },
      internalShow: this.show,
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = { ...newValue };
      },
      deep: true
    },
    show(newShow) {
      this.internalShow = newShow;
    },
    internalShow(newShow) {
      this.$emit('update:show', newShow);
    }
  },
  methods: {
    save() {
      this.$emit("save", this.internalValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.primary-btn {
  color: white;
  background-color: $ausloans-blue !important;
}
</style>